module.exports = __webpack_public_path__ + "media/components/dashboard/icons/spends-55b1245af81e6e8b2095002802eb5368.svg";